import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const WhoWeAre = () => {
     useEffect(() => {
        document.title = 'Who We Are -  Mary Matha Cmi  Academy';   
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
        <li><Link to="/"> Home</Link> </li> 
        <li>  School </li> 
        <li>Who We Are </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Who We Are  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <p> Mary Matha CMI Academy, was designed and built in 2025 with the humble beginning of classes 1 to 6 by CMI Fathers. It is established with the objective of empowering and moulding the coming generation in the light of holistic approach. Its primary initiative is to assist the children in the formation of character as well as academic growth.</p>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default WhoWeAre
